<div class="row row-padding-bottom client-plans" style="padding-top: 15px;">
  <div class="medium-6">
    <span style="font-size: 20px;font-weight: 500;color: #333333">Tax Plans</span>
  </div>
  <div class="medium-12">
    <div class="row"  style="background: #FFFFFF;">
      <div class="column large-4 medium-4 small-4" style="font-size: 14px !important;padding: 0">
        <div style="border: 1px solid #D0D5DD;border-radius: 4px;padding: 5px 14px;">
          <input style="border-bottom: none !important;margin-bottom: 0;" type="text" [(ngModel)]="searchKey" placeholder="Search plan" (keyup)="filterData()"/>
        </div>
      </div>
      <div class="column large-8 medium-8 small-8" style="font-size: 14px !important;padding: 0">
        <div class="float-right" style="margin-right: 10px;">
          <span class="float-right text-left tasks-filter" >
            <app-client-plans-search [tags]="filters"></app-client-plans-search>
          </span>
        </div>
        <div class="float-right pointer" style="margin: 10px 10px;color: #1570EF;display: inline-flex;" (click)="addNewTaxPlan()">
          <i class="material-icons">add</i><span style="position: relative;top: 2px;">Create a new Tax Plan</span>
        </div>
      </div>
    </div>
  </div>
  <div class="medium-12" style="margin-top: 10px;">
    <div class="row no-hover client-todos tax-strategy client-plans badge-tables" style="height: 27vh;overflow-y: auto; padding: 0;">
      <div class="medium-12 large-12 tpiq-paginated-table invoices scenarios">
        <table style="margin-top: 0 !important;">
          <thead>
          <tr>
            <th class="pointer" (click)="columnSort(column, columns)" *ngFor="let column of columns" attr.sortable="{{column['sortable'] == true}}">
              <span>{{column.title}}</span>
              <span class="float-right">
            <span *ngIf="column.sortType == 'asc'">
              <i class="icon ion-ios-arrow-up sort-indicator"></i>
            </span>
            <span *ngIf="column.sortType == 'desc'">
              <i class="icon ion-ios-arrow-down sort-indicator"></i>
            </span>
          </span>
            </th>
            <th class="pointer"></th>
          </tr>
          </thead>
          <tbody>
          <ng-template [ngIf]="userTableData && userTableData.length == 0">
            <tr class="text-center">
              <td [attr.colspan]="columns.length">
                <div class="callout text-center">
                  <p>No Results Found.</p>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template [ngIf]="userTableData && userTableData.length > 0">
            <tr *ngFor="let row of userTableData">
              <td *ngFor="let col of columns;let idx=index" [ngClass]="col.name == 'planActions' ? 'select-action': ''">
                <div class="pointer" *ngIf="col.name != 'name' && col.name != 'roi' && col.name != 'homeState' && col.name != 'status'" (click)="showPlan(row)">
                  {{row[col.name]}}
                </div>
                <div class="pointer" [ngClass]="col.name == 'name' ? 'plan-name-ellipsis' : ''" *ngIf="col.name == 'name'" (click)="showPlan(row)">
                  <span class='icon plan-paid' *ngIf="currentSubscription && currentSubscription.includes('Pay-Per-Tax-Plan') && row['paid']" style="margin-right: 10px;">Paid</span>{{row[col.name]}}
                </div>
                <div class="pointer" *ngIf="col.name == 'roi'" (click)="showROI(row)">{{ row[col.name] ? row[col.name] : 'Unlimited, No Fees' }}</div>
                <div class="pointer badge-tooltip" *ngIf="!userReadOnly && col.name == 'status' && col['status-col']">
                  <div class="tpiq-paginated-table status-cell" *ngIf="!row[col.name] || row[col.name].length==0" (click)="onMouseClick($event, row, col)">
                    <a class="action">
                      <span class="name-badge name-badge-add add-icon show-on-hover add-status-icon">
                          <i class="material-icons plus-icon">add_circle_outline</i>
                      </span>
                    </a>
                  </div>
                  <div class="status-cell" *ngIf="row[col.name]">
                    <span class="status-tracker" (click)="onMouseClick($event, row, col)">{{row[col.name]}}</span>
                  </div>
                </div>
                <div class="pointer badge-tooltip" *ngIf="userReadOnly && col.name == 'status' && col['status-col']">
                  <div class="status-cell" *ngIf="row[col.name]">
                    <span class="status-tracker">{{row[col.name]}}</span>
                  </div>
                </div>
                <div class="pointer badge-tooltip" *ngIf="!userReadOnly && col.name == 'homeState' && col['status-col']">
                  <div class="tpiq-paginated-table status-cell" *ngIf="!row[col.name] || row[col.name].length==0" (click)="onMouseClick($event, row, col)">
                    <a class="action">
                      <span class="name-badge name-badge-add add-icon show-on-hover add-status-icon">
                          <i class="material-icons plus-icon">add_circle_outline</i>
                      </span>
                    </a>
                  </div>
                  <div class="status-cell" *ngIf="row[col.name]">
                    <span class="status-tracker" (click)="onMouseClick($event, row, col)">{{row[col.name]}}</span>
                  </div>
                </div>
                <div class="pointer badge-tooltip" *ngIf="userReadOnly && col.name == 'homeState' && col['status-col']">
                  <div class="status-cell" *ngIf="row[col.name]">
                    <span class="status-tracker">{{row[col.name]}}</span>
                  </div>
                </div>

                <div class="scenario-dropdown action-dropdown" *ngIf="col.name == 'planActions' && !userReadOnly">
                  <app-tpiq-select-dropdown [setData]="actionsData" [includeNone]="false" (onValueSelect)="applyPlanAction($event, row)"
                                         [setDefaultValue]="" [setSearchKey]="'name'" [setPlaceHolder]="'Actions'" [setValueKey]="'name'"></app-tpiq-select-dropdown>
                </div>
              </td>
              <td>
                <div class='badge-tooltip'>
                  <a class='action' data-action='publish' *ngIf="estimateAccess && row['hasEstimate']"><span class='icon badge je-badge' (click)="navigateToTaxEstimates(row)">ES</span></a>
                  <a class='action' data-action='delete'><span class='todo-del' *ngIf="!userReadOnly" (click)="deletePlanFromTable(row)"><i class="material-icons delete">delete</i></span></a>
                </div>
              </td>
            </tr>
          </ng-template>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>

<div id="widget-container" style="height: 250px;width: 250px;z-index: 1002;position: absolute;left: -9999px;" *ngIf="displayWidget" (clickOutside)="closeContainer()">
  <div class="tpiq-input-search badge-input-search">
    <div *ngIf="selectedCol['editable']" class="option-picker-wrapper dropdown">
      <div class="wrapper-selection" *ngIf="selectedRow[selectedCol.name]">
        <div class="badge-menu-item" style="background-color: rgb(171, 170, 172)">
          <div class="item-name float-left">{{selectedRow[selectedCol.name]}}</div>
        </div>
      </div>
      <div class="wrapper-search" [hidden]="widgetLoader">
        <input type="text" placeholder="Search..." class="input-field" (keyup)="filterEntries($event)"  [(ngModel)]="dropSearchString" />
      </div>
      <div class="tpiq-loading-wheel" style="position: initial !important;height: 25vh !important" *ngIf="widgetLoader">
        <div align="center" class="fond" style="padding-top: 110px !important;">
          <div class="contener_general">
            <div class="contener_mixte"><div class="ballcolor ball_4">&nbsp;</div></div>
            <div class="contener_mixte"><div class="ballcolor ball_3">&nbsp;</div></div>
            <div class="contener_mixte"><div class="ballcolor ball_2">&nbsp;</div></div>
            <div class="contener_mixte"><div class="ballcolor ball_1">&nbsp;</div></div>
          </div>
        </div>
      </div>
      <ng-template [ngIf]="searchEntries.length > 0">
        <div class="wrapper-options">
          <div class="badge-menu-item" [style.color]="'#FFF'" *ngFor="let entry of searchEntries; let idx = index" (click)="triggerOnSelect($event, entry)">
            {{entry.name}}
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>


<div *ngIf="reveal['customStatus']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['customStatus']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 40%;" [ngClass]="{'tpiq-reveal': reveal['customStatus']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Status of a Client</span>
      <span class="float-right pointer" (click)="hideReveal('customStatus')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;">
      <div class="row row-padding-reveal">
        <div class="medium-7">
          <label>
            Enter custom status:
            <input type="text" [(ngModel)]="planCustomStatus" placeholder="Enter status" style="font-size: 1.0em !important;"/>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="medium-12 columns row-padding-reveal">
          <button class="button small float-right" (click)="updatePlanStatus()">Update</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['duplicate-plan']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['duplicate-plan']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 50%;top: 15vh;" [ngClass]="{'tpiq-reveal': reveal['duplicate-plan']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Duplicate Plan</span>
      <span class="float-right pointer" (click)="hideReveal('duplicate-plan')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;">
      <div class="row row-padding-reveal">
        <div class="medium-6 columns">
          <label>
            Enter name of new plan*:
            <input type="text" [(ngModel)]="duplicatePlanName" placeholder="Enter name" style="font-size: 1.0em !important;"/>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            Enter plan year*:
            <input type="text" [(ngModel)]="duplicatePlanYear" placeholder="2020" style="font-size: 1.0em !important;"/>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="medium-12 columns row-padding-reveal">
          <button class="button small float-right" (click)="createDuplicate()">Create</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['rename-plan']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['rename-plan']}">
    <div class="reveal" style="padding: 0; border: none; width: 50%;top: 15vh;" (click)="stopPropagation($event)" [ngClass]="{'tpiq-reveal': reveal['rename-plan']}">
      <div style="height: 50px; padding: 15px; color: #333333;">
        <span class="float-left">Rename Plan</span>
        <span class="float-right pointer" (click)="hideReveal('rename-plan')">X</span>
      </div>
      <div style="padding: 0 15px;">
        <hr style="margin: 0;"/>
      </div>
      <div class="body reveal-publish" style="padding: 15px;">
        <div class="row row-padding-reveal">
          <div class="medium-6">
            <label>
              Enter name:
              <input type="text" [(ngModel)]="newPlanName" placeholder="Enter new name"/>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="medium-12 columns">
            <button class="button small float-right" (click)="renamePlan()">Rename</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['extraOptions']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['extraOptions']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 50%;top: 15vh" [ngClass]="{'tpiq-reveal': reveal['extraOptions']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Info</span>
      <span class="float-right pointer" (click)="hideReveal('extraOptions')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish d-flex align-items-center justify-content-center" style="height: 20vh;">
      Hitting your browsers soon.
    </div>
  </div>
</div>

<div *ngIf="reveal['editClient']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['editClient']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 50%;" [ngClass]="{'tpiq-reveal': reveal['editClient']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Update Client</span>
      <span class="float-right pointer" (click)="hideReveal('editClient')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body" style="padding: 15px;">
      <tpiq-create-update-client [editMode]="true" [clientId]="clientId" (onCancelCreateOrUpdateOfClient)="hideReveal('editClient')"
                                 (onCreationOrUpdateOfClient)="refreshClient()"></tpiq-create-update-client>
    </div>
  </div>
</div>

<div id="client-plans" style="display: none;">
  <table style="font-size: 15px; margin-top: 30px; width: 100%;">
    <thead style="background: none;">
    <tr style="height: 30px;">
      <td style="text-align: center; font-size: 25px;">{{clientData.firstName + ' ' + clientData.lastName}} Plans</td>
    </tr>
    <tr style="height: 10px;">
      <td></td>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td>
        <table style="margin-top: 0 !important;border: 1px solid #ddd;width: 100%;">
          <thead>
          <tr>
            <th class="pointer" *ngFor="let column of columnsForPdf" style="border: 1px solid #ddd;padding: 10px;">
              <span>{{column.title}}</span>
            </th>
          </tr>
          </thead>
          <tbody>
          <ng-template [ngIf]="userTableData && userTableData.length == 0">
            <tr class="text-center">
              <td [attr.colspan]="columns.length">
                <div class="callout text-center">
                  <p>No Results Found.</p>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template [ngIf]="userTableData && userTableData.length > 0">
            <tr *ngFor="let row of userTableData">
              <td *ngFor="let col of columnsForPdf;let idx=index" style="border: 1px solid #ddd;padding: 10px;">
                <span>{{row[col.name]}}</span>
              </td>
            </tr>
          </ng-template>
          </tbody>
        </table>
      </td>
    </tr>
    </tbody>
  </table>
</div>

<div *ngIf="reveal['addNewTaxplan']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['addNewTaxplan']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 50%;" [ngClass]="{'tpiq-reveal': reveal['addNewTaxplan']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Create a New Tax Plan</span>
      <span class="float-right pointer" (click)="hideReveal('addNewTaxplan')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body new-input-fields" style="padding: 15px;">
      <div #scrollContainer class="row" style="margin-top: 10px;height: 65vh;overflow-y: scroll;">
        <div class="medium-12 column">
          <div class="address-bar row-margin">
            <div style="flex:2" class="popup-label">Plan Name*</div>
            <div style="flex:1">
              <label>
                <input type="text" [(ngModel)]="newTaxPlan.name" placeholder="Plan Name"/>
              </label>
            </div>
          </div>
        </div>
        <div class="medium-6 column">
          <div class="address-bar row-margin">
            <div style="flex:2" class="popup-label">Total Tax*</div>
            <div style="flex:1">
              <label>
                <input type="text" placeholder="Total Tax" [(ngModel)]="newTaxPlan.totalTax" model-numeral [format]="'$0,0.00'" [locale]="'usd'" (blur)="calculateEffectiveRate()"/>
              </label>
            </div>
          </div>
        </div>
        <div class="medium-6 column">
          <div class="address-bar row-margin">
            <div style="flex:2" class="popup-label">Taxable Income*</div>
            <div style="flex:1">
              <label>
                <input type="text" placeholder="Taxable Income" [(ngModel)]="newTaxPlan.taxableIncome" model-numeral [format]="'$0,0.00'" [locale]="'usd'" (blur)="calculateEffectiveRate()"/>
              </label>
            </div>
          </div>
        </div>
        <div class="medium-6 column">
          <div class="address-bar row-margin">
            <div style="flex:2" class="popup-label">
              Effective Rate(%)*
            </div>
            <div style="flex:1">
              <label style="margin-bottom: 0;">
                <input type="text" placeholder="24" [(ngModel)]="newTaxPlan.effectiveRate" style="margin-bottom: 0;"/>
              </label>
              <div style="font-size: 9px; color: #1570EF; line-height: 1; margin-top: 2px;">
                Calculated using (Total tax / Total taxable income)
              </div>
            </div>
          </div>
        </div>
        <div class="medium-6 column">
          <div class="address-bar row-margin">
            <div style="flex:2" class="popup-label">Filing Status*</div>
            <div style="flex:1">
              <label>
                <app-tpiq-select-dropdown
                  [includeNone]="false"
                  [setData]="filingStatusList"
                  [setPlaceHolder]="'Select Filing Status'"
                  [setSearchKey]="'name'"
                  [setValueKey]="'name'"
                  [setDefaultValue]="defaultFilingStatus"
                  (onValueSelect)="onFilingStatusSelect($event)">
                </app-tpiq-select-dropdown>
              </label>
            </div>
          </div>
        </div>
        <div class="medium-6 column">
          <div class="address-bar row-margin">
            <div style="flex:2" class="popup-label">
              <span class="text-center">Marginal Rate(%)*</span>
              <span class="text-center badge-tooltip">
              <i class="icon ion-ios-information-outline" (click)="showRatesInfo()"></i>
              <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">
                Click here to link to current marginal tax rates
              </span>
            </span>
            </div>
            <div style="flex:1">
              <label>
                <input type="text" placeholder="21" [(ngModel)]="newTaxPlan.marginalRate"/>
              </label>
            </div>
          </div>
        </div>
        <div class="medium-6 column">
          <div class="address-bar row-margin">
            <div style="flex:2" class="popup-label">
              <span class="text-center">Cap Gains Rate(%)*</span>
              <span class="text-center badge-tooltip">
              <i class="icon ion-ios-information-outline" (click)="showRatesInfo()"></i>
              <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">
                Click here to link to current cap gains tax rates
              </span>
            </span>
            </div>
            <div style="flex:1">
              <label>
                <input type="text" placeholder="22" [(ngModel)]="newTaxPlan.capGainRate"/>
              </label>
            </div>
          </div>
        </div>
        <div class="medium-6 column">
          <div class="address-bar row-margin">
            <div style="flex:2" class="popup-label">C Corp Flat Rate(%)*</div>
            <div style="flex:1">
              <label>
                <input type="text" placeholder="21" [(ngModel)]="newTaxPlan.ccropFlatRate"/>
              </label>
            </div>
          </div>
        </div>
        <div class="medium-6 column">
          <div class="address-bar row-margin">
            <div style="flex:2" class="popup-label">Tax Plan Year*</div>
            <div style="flex:1">
              <label>
                <app-tpiq-select-dropdown [setData]="years" [includeNone]="false" (onValueSelect)="setYear($event)"
                                       [setDefaultValue]="newTaxPlan.taxYear || ''" [setSearchKey]="'name'" [setPlaceHolder]="'Tax Plan Year'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
              </label>
            </div>
          </div>
        </div>
        <div class="medium-12 column">
          <div class="address-bar row-margin">
            <div style="flex:2" class="popup-label">
              <span class="text-center">Home State*</span>
            </div>
            <div style="flex:1">
              <label>
                <app-tpiq-select-dropdown [setData]="states" [setPlaceHolder]="'Select State'" [includeNone]="false" [setSearchKey]="'name'" [setValueKey]="'short'" [setDefaultValue]="newTaxPlan.homeState"
                                       (onValueSelect)="onHomeStateSelect($event)"></app-tpiq-select-dropdown>
              </label>
            </div>
          </div>
        </div>
        <div class="medium-6 column">
          <div class="address-bar row-margin">
            <div style="flex:2">
              <span class="text-center" class="popup-label">Individual State Rate(%)</span>
              <span class="text-center badge-tooltip">
              <i class="icon ion-ios-information-outline" (click)="showStateRatesInfo('individual')"></i>
              <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">Click here to link to current individual state rates</span>
            </span>
            </div>
            <div style="flex:1">
              <label>
                <input type="text" placeholder="10" [(ngModel)]="newTaxPlan.individualStateRate"/>
              </label>
            </div>
          </div>
        </div>
        <div class="medium-6 column">
          <div class="address-bar row-margin">
            <div style="flex:2">
              <span class="text-center" class="popup-label">Corporate State Rate(%)</span>
              <span class="text-center badge-tooltip">
              <i class="icon ion-ios-information-outline" (click)="showStateRatesInfo('corporate')"></i>
              <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">Click here to link to current corporate state rates</span>
            </span>
            </div>
            <div style="flex:1">
              <label>
                <input type="text" placeholder="10" [(ngModel)]="newTaxPlan.corporateStateRate"/>
              </label>
            </div>
          </div>
        </div>
        <div class="medium-12 column">
          <div class="address-bar row-margin">
            <div style="flex:2" class="popup-label">Description</div>
            <div style="flex:1">
              <label>
                <div style="min-height:50px;border:1px solid #cacaca;padding:10px;margin-bottom:20px;" [froalaEditor]="editorOptions" [(froalaModel)]="newTaxPlan.description"></div>
              </label>
            </div>
          </div>
        </div>
        <div class="medium-12 column" style="background: rgba(234, 236, 240, 0.5);border-radius: 4px;padding-bottom: 15px;">
          <div class="address-bar row-margin">
            <span class="pointer popup-label" style="color: #1570EF" (click)="addCustomTaxRate()"><i class="icon ion-ios-plus-outline"></i>Custom Rate</span>
          </div>
          <div class="row address-bar row-margin" *ngFor="let customTaxRate of newTaxPlan.customTaxRates;let idx = index">
            <div class="medium-6 columns">
              <div style="flex:2">
                <input type="text" class="custom-tax-rate-name" placeholder="Tax Rate Name" [(ngModel)]="customTaxRate.name"/>
              </div>
            </div>
            <div class="medium-6 columns">
              <div style="flex:1">
                <input type="text" class="custom-tax-rate" placeholder="25" [(ngModel)]="customTaxRate.rate"/>
                <span class="pointer custom-rate-remove" (click)="removeCustomTaxRate(idx)"><i class="icon ion-ios-trash-outline"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 20px;">
        <div class="medium-12">
          <button class="button small float-right" [ngStyle]="{'background': (newTaxPlan && newTaxPlan.name) ? '#1570EF':'#98A2B3'}" (click)="createTaxPlan()">Create</button>
          <button class="button small float-right" style="border: 1px solid #D0D5DD;border-radius: 6px;background: #FFFFFF;color:#333333;" (click)="hideReveal('addNewTaxplan')">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['creationFail']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['creationFail']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 50%;" [ngClass]="{'tpiq-reveal': reveal['creationFail']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-right pointer" (click)="hideReveal('creationFail')">X</span>
    </div>

    <div class="body reveal-publish d-flex align-items-center justify-content-center" style="padding: 0 15px 15px 15px;">
      <div class="mb-5" style="color: #FF3219">{{errorMessage}}</div>
    </div>
  </div>
</div>
